import { useEffect, useState } from "react";
import HottestRecruitmentQuestionList from "../../components/recruitment-question/HottestRecruitmentQuestionList/HottestRecruitmentQuestionList";
import RecruitmentQuestionAllQuestionsTable from "../../components/recruitment-question/RecruitmentQuestionAllQuestionsTable/RecruitmentQuestionAllQuestionsTable";
import RecruitmentQuestionRecommendListCard from "../../components/recruitment-question/RecruitmentQuestionRecommendListCard/RecruitmentQuestionRecommendListCard";
import "./recruitment_question_set.scss";
import httpclient from "../../service/httpclient";
import { Badge, Spin } from "antd";
import RecruitmentQuestionMembershipCard from "../../components/recruitment-question/RecruitmentQuestionMembershipCard/RecruitmentQuestionMembershipCard";
import useWindowWidth from "../../hooks/useWindowWidth";
import { saveLotterySharePurchaseAttribution } from "../../utils/lotteryShareAttribution";

function RecruitmentQuestionSet() {
  const [questionLists, setQuestionLists] = useState(null);
  const fetchQuestionLists = () =>
    httpclient.getAllVisibleRecruitmentQuestionLists().then((res) => {
      setQuestionLists(res);
    });
  useEffect(() => {
    fetchQuestionLists();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const shareKey = params.get("lottery_share_key");
    if (!shareKey) return;

    saveLotterySharePurchaseAttribution(shareKey);

    const today = new Date().toISOString().slice(0, 10);
    const cacheKey = `lottery_share_visit_${shareKey}_${today}`;
    if (!sessionStorage.getItem(cacheKey)) {
      sessionStorage.setItem(cacheKey, "1");
      httpclient.recordLotteryShareVisit(shareKey).catch(() => {});
    }

    params.delete("lottery_share_key");
    const nextSearch = params.toString();
    const nextUrl = `${window.location.pathname}${
      nextSearch ? `?${nextSearch}` : ""
    }${window.location.hash}`;
    window.history.replaceState(null, "", nextUrl);
  }, []);

  const [membershipStatus, setMembershipStatus] = useState(null);
  useEffect(() => {
    httpclient.getOneProductMembership(1).then((res) => {
      const expiredAt = res?.record?.expire_time
        ? new Date(res.record.expire_time)
        : null;
      setMembershipStatus({
        hasMembership: !!expiredAt && Date.now() < expiredAt.getTime(),
        hasMembershipRecord: !!res?.record,
      });
    });
  }, []);

  const getListBadge = (list) => {
    if (list.title?.toLowerCase().includes("ldo")) {
      return { text: "新", color: "pink" };
    }
    if (list.can_take_exam) {
      return { text: "可模拟笔试" };
    }
    return {};
  };

  const { windowWidth } = useWindowWidth();

  return (
    <div className="recruitment-question-set">
      <div className="recruitment-question-set-wrapper">
        <div id="membership">
          {/* <div className="section-header">
            <div className="section-title">获取会员</div>
          </div> */}
          <div className="section-container">
            <RecruitmentQuestionMembershipCard
              hasMembership={membershipStatus?.hasMembership}
              hasMembershipRecord={membershipStatus?.hasMembershipRecord}
            />
          </div>
        </div>
        <div
          id="recommend-list"
          style={{
            gridColumn: windowWidth > 898 ? "1 / 2" : "1 / 3",
          }}
        >
          {/* <div className="section-header">
            <div className="section-title">推荐题单</div>
          </div> */}
          <div className="section-container">
            {questionLists ? (
              questionLists.map((list) => {
                const { text, color } = getListBadge(list);
                return (
                  <div key={list.title} className="card-item">
                    {text ? (
                      <Badge.Ribbon text={text} color={color}>
                        <RecruitmentQuestionRecommendListCard list={list} />
                      </Badge.Ribbon>
                    ) : (
                      <RecruitmentQuestionRecommendListCard list={list} />
                    )}
                  </div>
                );
              })
            ) : (
              <div style={{ textAlign: "center", width: "100%" }}>
                <Spin />
              </div>
            )}
          </div>
        </div>
        <div id="hottest-questions">
          <div className="section-header">
            <div className="section-title">热门题目</div>
          </div>
          <div className="section-container">
            <HottestRecruitmentQuestionList />
          </div>
        </div>
        <div id="all-questions">
          <div className="section-header">
            <div className="section-title">全部题目</div>
          </div>
          <div className="section-container">
            <RecruitmentQuestionAllQuestionsTable />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecruitmentQuestionSet;
